export default __webpack_public_path__ + "static/media/mrduma.07829f04.jpg";